import React, { useCallback, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { WarningOutlined } from '@ant-design/icons'
import { Button, Modal, Table } from 'antd'
import { get } from 'lodash'
import PropTypes from 'prop-types'

import { APP_ROUTES, METADATA_TYPES, PAGINATION } from '../../constants'

const MetadataTreeErrorsModal = ({ errors }) => {
  const [isModalVisible, setIsModalVisible] = useState(false)

  const columns = useMemo(
    () => [
      {
        title: 'Name',
        dataIndex: 'name',
      },
      {
        title: 'Type',
        dataIndex: 'type',
        render: type => get(METADATA_TYPES, `${type}.labelSingular`),
      },
      {
        title: 'Link',
        // eslint-disable-next-line react/prop-types
        render: ({ id, type }) => (
          <Link
            to={`${get(
              APP_ROUTES,
              `${get(METADATA_TYPES, `${type}.value`)}.link`,
            )}/${id}`}
          >
            {window.location.host}
            {get(APP_ROUTES, `${get(METADATA_TYPES, `${type}.value`)}.link`)}/
            {id}
          </Link>
        ),
      },
    ],
    [],
  )

  const pagination = useMemo(
    () => ({
      pageSizeOptions: PAGINATION.DEFAULT_PAGINATION_SIZE_OPTIONS,
      pageSize: PAGINATION.DEFAULT_PAGE_SIZE,
    }),
    [],
  )

  const showModal = useCallback(() => {
    setIsModalVisible(true)
  }, [])

  const hideModal = useCallback(() => {
    setIsModalVisible(false)
  }, [])

  return (
    <>
      <Button danger onClick={showModal} icon={<WarningOutlined />}>
        Errors
      </Button>

      <Modal width={900} onCancel={hideModal} visible={isModalVisible}>
        <Table
          dataSource={errors}
          rowKey="id"
          columns={columns}
          pagination={pagination}
        />
      </Modal>
    </>
  )
}

MetadataTreeErrorsModal.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default MetadataTreeErrorsModal
